import Page from 'flarum/components/Page';
import Link from 'flarum/components/Link';
import AboutHeader from '../../components/AboutContent/AboutHeader';

export default class HistoryPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Send history push
    app.history.push('aboutHistory');

    this.bodyClass = 'App--AboutPage';

    app.setTitle('History of KVS');
  }

  view() {
    return (
      <div className={'Site-AboutPage'}>
        <div className={'container'}>
          <AboutHeader selected={'history'} />

          <div className={ 'content-box content-padding'}>
            <h2>Khát VongSong qua các năm</h2>
            <p>
                Vào  <strong>ngày 10 tháng 2 năm 2009</strong> KVS được thành lập bởi LDC, <code>MacKen</code> và <code>Litalino</code>. Mục tiêu là thành lập một cộng đồng phát triển nói tiếng Việt.
            </p>
            <p>
                KVS đã tồn tại được 14 năm kể từ <strong>ngày 21 tháng 9 năm 2023</strong>,  vì vậy thật vui khi được quay ngược thời gian. KVS đã phát triển như thế nào trong những năm qua?
            </p>
          </div>

          <div className={'Site-AboutPage-timeline'}>
            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>2009 - Năm khởi đầu</div>

              <div className={'content-box'}>
                <p>
                  
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>2010</div>

              <div className={'content-box'}>
                <p>
                 
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>2011</div>

              <div className={'content-box'}>
                <p>
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>2012</div>

              <div className={'content-box'}>
                <p>
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>2013</div>

              <div className={'content-box'}>
                <p>
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>......</div>

              <div className={'content-box'}>
                <p>
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>2023 - 21 tháng 9</div>

              <div className={'content-box'}>
                <p>Quý này, KVS đã nhận được một trang web mới phù hợp với thiết kế mới của chúng tôi.</p>
                <p>
                  <Link href={'#'}>
                  Cập nhật cộng đồng <i className={'fas fa-angle-right'} />
                  </Link>
                </p>
              </div>
            </div>

            <div className={'Site-AboutPage-timeline-section'}>
              <div className={'timeline-year'}>Hiện nay</div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
